import { render, staticRenderFns } from "./NewAddressPopup.vue?vue&type=template&id=2d77b532&scoped=true"
import script from "./NewAddressPopup.vue?vue&type=script&lang=js"
export * from "./NewAddressPopup.vue?vue&type=script&lang=js"
import style0 from "./NewAddressPopup.vue?vue&type=style&index=0&id=2d77b532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77b532",
  null
  
)

export default component.exports